import _ from 'lodash';
import React, { forwardRef, useMemo, useState } from 'react';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useInterval } from '../../hooks/use-interval';
import { useStorage } from '../../hooks/use-storage';
import { usePaymentSelectOrdersInstructionsModal } from '../../screens/payment/payment-select-orders-instructions-modal';
import { layoutDefaults } from '../../utils/layout-defaults';
import {
  filterByUser,
  isSelectable,
  sortOrdersByCreation,
} from '../../utils/manager/order-manager';
import { Order } from './order';

function Orders(
  {
    selectedOrders,
    singleOrder,
    onSelectInstructions,
    onSelectedOrdersChange: setSelectedOrders,
    cancelDisabled,
    onCancel,
  },
  ref
) {
  const { orders, user, spot } = useStorage();
  const { t } = useTranslation();
  const [refreshTime, setRefreshTime] = useState(new Date());
  const { showPaymentSelectOrdersInstructionsModal } =
    usePaymentSelectOrdersInstructionsModal();

  useInterval(() => {
    setRefreshTime(new Date());
  }, 5000);

  const linkTitle = useMemo(
    () =>
      // OBS: Removi pois não faz sentido fazer essa distinção.
      //      Ou melhor, talvez faça sentido sim, mas para mesas compartilhadas/
      //      não-compartilhadas, colocando o text "Selecionar tudo".
      // if (spot?.prepaid) {
      //   return selectedOrders.length > 0
      //     ? t('orders.clear-selection')
      //     : t('orders.select-my-items');
      // }

      selectedOrders.length > 0
        ? t('orders.clear-selection')
        : t('orders.select-my-orders'),
    [selectedOrders, spot]
  );

  const userOrders = useMemo(
    () => filterByUser(orders, user).filter((o) => isSelectable(o)),
    [orders, user]
  );

  const linkEnabled = useMemo(() => !_.isEmpty(userOrders), [userOrders]);

  const classes = useStyles({ linkEnabled });

  const handleLinkClick = async () => {
    if (selectedOrders.length > 0) {
      setSelectedOrders([]);
    } else {
      let lOrders = userOrders?.filter((o) => isSelectable(o));

      if (_.isEmpty(lOrders)) {
        // TODO Alertar
        await showPaymentSelectOrdersInstructionsModal();
        onSelectInstructions();
        // const _orders = orders.filter((o) => isSelectable(o));
      } else {
        lOrders = userOrders.map((o) => {
          o.flashAt = new Date();
          return o;
        });

        setSelectedOrders(lOrders);
      }
    }
  };

  return (
    <FadeIn className={classes.container}>
      <div ref={ref} />
      {sortOrdersByCreation(orders).map((order, index) => (
        <Order
          key={order.id}
          index={index}
          count={orders.length}
          order={order}
          refreshTime={refreshTime}
          selectedOrders={selectedOrders}
          onSelectedOrdersChange={setSelectedOrders}
          cancelDisabled={cancelDisabled}
          prepaid={spot?.prepaid}
          onCancel={onCancel}
        />
      ))}

      {!singleOrder && user && (
        <div
          className={classes.link}
          onClick={linkEnabled ? handleLinkClick : null}
          aria-hidden
        >
          {linkTitle}
        </div>
      )}
    </FadeIn>
  );
}

const useStyles = createUseStyles({
  container: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    // border: "1px solid white",
  },
  link: {
    cursor: 'pointer',
    textAlign: 'right',
    fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.secondaryColor,
    textTransform: 'uppercase',
    paddingTop: layoutDefaults.smallerVerticalMargin,
    opacity: ({ linkEnabled }) => (linkEnabled ? null : layoutDefaults.opacity),
    // border: "1px solid white",
  },
});

const OrdersRef = forwardRef(Orders);

export { OrdersRef as Orders };
